import { render, staticRenderFns } from "./ReplyList.vue?vue&type=template&id=7538b4db&scoped=true&"
import script from "./ReplyList.vue?vue&type=script&lang=js&"
export * from "./ReplyList.vue?vue&type=script&lang=js&"
import style0 from "./ReplyList.vue?vue&type=style&index=0&id=7538b4db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7538b4db",
  null
  
)

export default component.exports